module.exports = __webpack_public_path__ + "static/media/hotel.870fc1b5.jpg";